<template>
  <el-row class="text-align-left">
    <el-col :span="24" class="banner">
      <div class="banner-image">
        <img src="@/assets/OOCL_logo.svg" class="oocl-logo">
      </div>
    </el-col>
    <el-col :xl="21" :lg="20" :md="19" :sm="18">
      <div class="content">
        <div class="content-1 content-margin">Improve Your Experience / 升级您的体验</div>
        <div class="content-3">Using older or non-compatible browsers will not be guarantee<br> proper functionality on all functions on the site.</div>
        <div class="content-3">请注意您正在使用的浏览器已经不支持本网站的功能<br>您会在使用本网站功能时遇到兼容性问题。</div>
        <div class="content-4">Recommended Browser / 推荐浏览器</div>
        <div class="content-3">Here's list of browsers we support and where you can download them.</div>
        <div class="content-3">我们建议您可以在这里下载我们支持的浏览器。</div>
        <div class="link-browser">
          <div class="content-img">
            <a href="http://windows.microsoft.com/en-us/internet-explorer/download-ie" target="_blank" class="inline-block icon-space">
              <img src="@/assets/ie_logo.png" class="browser-icon">
            </a>
            <div class="content-5">
              <a href="http://windows.microsoft.com/en-us/internet-explorer/download-ie" target="_blank" class="inline-block text-align-center">Microsoft Internet Explorer<br>11 or above<br> Microsoft Internet Explorer<br>11或以上</a>
            </div>
          </div>
          <div class="content-img mf-margin">
            <a href="https://www.mozilla.org/firefox/" target="_blank" class="inline-block icon-space">
              <img src="@/assets/firefox_logo.png" class="browser-icon">
            </a>
            <div class="content-5">
              <a href="https://www.mozilla.org/firefox/" target="_blank" class="inline-block text-align-center">Mozilla Firefox<br>火狐浏览器</a>
            </div>
          </div>
          <div class="content-img gc-margin">
            <a href="https://www.google.com/chrome/" target="_blank" class="inline-block icon-space">
              <img src="@/assets/chrome_logo.png" class="browser-icon">
            </a>
            <div class="content-5">
              <a href="https://www.google.com/chrome/" target="_blank" class="inline-block text-align-center">Google Chrome<br>谷歌浏览器</a>
            </div>
          </div>
        </div>
      </div>
    </el-col>
    <Footer></Footer>
  </el-row>
</template>

<script>
import Footer from '@/components/Footer.vue';
export default {
  components: {
    Footer
  }
};
</script>

<style scoped>
  .text-align-left {
    text-align: left;
  }
  .banner{
    position: fixed;
  }
  .banner-image {
    background-image: url("../../assets/assessment_banner.jpg");
    height: 185px;
    background-repeat: no-repeat;
    background-position: center;
  }

  .oocl-logo {
    margin-top: 50px;
    height: 50px;
    padding-left: 48px;
    position: relative;
  }

  .content {
    position: relative;
    top: 150px;
    left: 5%;
    width: 100%;
  }

  .content-margin {
    margin-top: 80px;
  }

  .content-1 {
    font-size: 50px;
    font-weight: bold;
    text-align: center;
    color: #d63246;
  }

  .content-3 {
    margin-top: 15px;
    font-size: 16px;
    color: #333333;
    text-align: center;
  }

  .content-4 {
    font-size: 31px;
    color: #d63246;
    text-align: center;
    font-weight: bold;
    margin-top: 18px;
  }

  .content-5 {
    text-align: center;
    font-size: 16px;
  }

  .link-browser {
    text-align: center;
  }

  .content-img {
    display: inline-block;
    margin-top: 28px;
    text-align: center;
    margin-right: 50px;
  }

  .inline-block {
    display: inline-block;
    *display: inline;
    *zoom: 1;
  }

  .text-align-center {
    text-align: center;
    margin-top: 30px;
    margin-bottom: 20px;
    line-height: 25px;
  }

  .mf-margin {
    position: relative;
    top: -50px;
    margin-right: 70px;
  }

  .gc-margin {
    position: relative;
    top: -50px;
  }

  a {
    color: -webkit-link;
    text-decoration: none;
  }

  .browser-icon {
    width: 84px;
    height: 84px;
    border: none;
  }
</style>



// WEBPACK FOOTER //
// src/pages/error/RejectAccess.vue